import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';
import {FindProductPriceService} from '../../services/find-product-price.service';
import {DateAsNumberService} from '../../services/date-as-number.service';
import {GeneralService} from '../../services/general.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {get as getLodash} from 'lodash';
import {DocumentTypes} from '../../definitions/document-types';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
    selector: 'app-add-accessories',
    templateUrl: './add-accessories.page.html',
    styleUrls: ['./add-accessories.page.scss'],
})
export class AddAccessoriesPage implements OnInit {

    @Input() accessories: any[];
    @Input() document: DocumentModel;
    @Input() package: string;
    @Input() equipment: DetaillineDTOModel;
    tempList: any = [];
    discount: number;
    currentDetailLine: DetaillineDTOModel;
    mobileConfiguration: MobileConfigurationModel;
    queryText: string;

    constructor(private modalController: ModalController,
                private lokiJs: LokijsService,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private findProductPriceService: FindProductPriceService,
                private dateAsNumber: DateAsNumberService,
                private generalServices: GeneralService,
                private collectionsNames: CollectionsNames,
                private docType: DocumentTypes,
                private configurationService: ConfigurationService) {
    }

    ngOnInit() {
        this.mobileConfiguration = this.configurationService.getMobileConfiguration();
        console.log(this.mobileConfiguration);
        this.initialize();
    }

    initialize() {
        this.tempList = [];
        for (const acc of this.accessories) {
            if (acc.pdesc) {
                let detailLineTemp = [];
                if (this.mobileConfiguration.mobilehireHealthCareInUse === 1) {
                    detailLineTemp = this.lokiJs.getCollection('equipment').chain().find({pdesc: acc.pdesc, stat: {$in: [1, 200]}}).data();
                } else {
                    detailLineTemp = this.lokiJs.getCollection('equipment').chain().find({pdesc: acc.pdesc}).data();
                }
                if (detailLineTemp.length > 0) {
                    if (detailLineTemp[0].typ === 'S') {
                        console.log(detailLineTemp);
                        for (const tempLine of detailLineTemp) {
                            const lineForArray = JSON.parse(JSON.stringify(tempLine));
                            lineForArray.overrideDescriptionNote = lineForArray.description;
                            lineForArray.qty = acc.qty;
                            this.tempList.push({equipment: lineForArray, isChecked: false});
                        }
                    } else {
                        detailLineTemp[0] = JSON.parse(JSON.stringify(detailLineTemp[0]));
                        detailLineTemp[0].overrideDescriptionNote = detailLineTemp[0].description;
                        detailLineTemp[0].qty = acc.qty;
                        this.tempList.push({equipment: detailLineTemp[0], isChecked: true});
                    }
                }
            } else if (acc.plu) {
                const detailLineTemp = this.lokiJs.getCollection('producttype').chain().find({plu: acc.plu}).data();
                if (detailLineTemp.length > 0) {
                    detailLineTemp[0] = JSON.parse(JSON.stringify(detailLineTemp[0]));
                    detailLineTemp[0].comment = detailLineTemp[0].description;
                    detailLineTemp[0].qty = acc.qty;
                    this.tempList.push({equipment: detailLineTemp[0], isChecked: true});
                }
            }
        }
    }

    async saveAccessories() {
        console.log(this.equipment);
        this.equipment.packageSeq = null;
        this.equipment.packageName = this.equipment.pdesc;
        this.equipment.packageSeq = this.dateAsNumber.dateAsNumber();
        for (const item of this.tempList) {
            if (item.isChecked) {
                let tempAcc = JSON.parse(JSON.stringify(item.equipment));
                if (this.equipment.typ === 'M') {
                    tempAcc.qty = this.equipment.qty;
                }
                tempAcc.packageName = this.equipment.pdesc;
                tempAcc.packageSeq = this.equipment.packageSeq;
                tempAcc.total = 0;
                if (tempAcc.pdesc) {
                    tempAcc = this.findEquipmentPriceService.getChargeLineAndDiscount(tempAcc, this.document.customer);
                    tempAcc.fromDate = this.equipment.fromDate;
                    tempAcc.toDate = this.equipment.toDate;
                } else if (tempAcc.plu) {
                    await this.findProductPriceService.findFinalPriceAndDiscount(tempAcc, this.document);
                }
                tempAcc.location = this.document.location;
                tempAcc.total = item.equipment.weeklyRate - item.equipment.weeklyRate * item.equipment.discount / 100;
                this.document.detailLines.push(tempAcc);
            }
        }
        this.modalController.dismiss();
    }


    fetchAccessories(event: any) {
        this.initialize();
        event.target.complete();
    }
}
